<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button fill="clear" color="light" (click)="onDismiss()">
                <ion-icon slot="start" name="arrow-back" color="dark"></ion-icon>
                <!-- <strong style="color:black;">{{ 'GLOBAL_BACK' | translate }}</strong> -->
            </ion-button>
        </ion-buttons>
        <ion-title class="ion-text-center">{{ 'SETTINGS' | translate }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-grid>
        <ion-row>
            <ion-col size="2">
                <ion-icon name="analytics"></ion-icon>
            </ion-col>
            <ion-col size="6">
                <ion-label>{{ 'SIMPLE_UNIT' | translate}}</ion-label>
            </ion-col>
            <ion-col size="4" class="end">
                <ion-select [(ngModel)]="trackingService.options.distanceUnit"  style="max-width: 100%">
                    <ion-select-option *ngFor="let unit of unitOptions" [value]="unit.key">
                    {{ unit.name }}
                    </ion-select-option>
                </ion-select>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="2">
                <ion-icon name="pause"></ion-icon>
            </ion-col>
            <ion-col size="8">
                <ion-label>{{ 'AUTO_PAUSE_CONFIGURE' | translate}}</ion-label>
            </ion-col>
            <ion-col size="2">
                <ion-checkbox [(ngModel)]="trackingService.options.autoPause"></ion-checkbox>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="2">
                <ion-icon name="navigate"></ion-icon>
            </ion-col>
            <ion-col size="8">
                <ion-label>{{ 'SHARE_POSITION' | translate}}</ion-label>
            </ion-col>
            <ion-col size="2">
                <ion-checkbox [(ngModel)]="trackingService.options.locationExport"
                    (ionChange)="locationExportChange()"></ion-checkbox>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="2">
                <img src="../../assets/imgs/claphands.svg">
            </ion-col>
            <ion-col size="8">
                <ion-label>{{ 'APPLAUSE_SOUND_CONFIGURE' | translate }}</ion-label>
            </ion-col>
            <ion-col size="2">
                <ion-checkbox [(ngModel)]="trackingService.options.applause"></ion-checkbox>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="2">
                <ion-icon name="aperture"></ion-icon>
            </ion-col>
            <ion-col size="8">
                <ion-label>{{ 'REALTIME_PLACES_CONFIGURE' | translate}}</ion-label>
            </ion-col>
            <ion-col size="2">
                <ion-checkbox [(ngModel)]="trackingService.options.placement"></ion-checkbox>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="2">
                <ion-icon name="color-fill"></ion-icon>
            </ion-col>
            <ion-col size="6">
                <ion-label>{{ 'TRACKING_COLOR' | translate}}</ion-label>
            </ion-col>
            <ion-col size="4" class="end">
                <ion-select [(ngModel)]="trackingService.options.trackingColor" (ionChange)="markerChanged = true"
                    style="max-width: 100%">
                    <ion-select-option *ngFor="let color of colorOptions" [value]="color.key">
                        {{ color.name }}
                    </ion-select-option>
                </ion-select>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="2">
                <ion-icon name="contrast"></ion-icon>
            </ion-col>
            <ion-col size="6">
                <ion-label>{{ 'TRACKING_LINE_WIDTH' | translate}}</ion-label>
            </ion-col>
            <ion-col size="4" class="end">
                <ion-select [(ngModel)]="trackingService.options.lineWidth" style="max-width: 100%">
                    <ion-select-option *ngFor="let line of lineWidthOptions" [value]="line.key">
                        {{ line.name }}
                    </ion-select-option>
                </ion-select>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="2">
                <ion-icon name="locate"></ion-icon>
            </ion-col>
            <ion-col size="6">
                <ion-label>{{ 'GPS_ACCURACY' | translate}}</ion-label>
            </ion-col>
            <ion-col size="4" class="end">
                <ion-select [(ngModel)]="trackingService.options.pluginAccuracy" (ionChange)="onPluginAccuracyChange()"
                    style="max-width: 100%">
                    <ion-select-option *ngFor="let accuracy of accuracyOptions" [value]="accuracy.key">
                        {{ accuracy.name }}
                    </ion-select-option>
                </ion-select>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="2">
                <ion-icon name="people"></ion-icon>
            </ion-col>
            <ion-col size="6">
                <ion-label>{{ 'SETTINGS_LANGUAGE' | translate}}</ion-label>
            </ion-col>
            <ion-col size="4" class="end">
                <ion-select multiple="false" [(ngModel)]="selectedLanguage" (ionChange)="changeLanguage()"
                    cancelText="{{'GLOBAL_CANCEL' | translate}}" okText="{{'GLOBAL_OK' | translate}}"
                    [placeholder]="selectedLanguage">
                    <ion-select-option *ngFor="let language of languageOptions" [value]="language.key">
                        {{ language.name }}
                    </ion-select-option>
                </ion-select>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="2">
                <ion-icon name="calendar"></ion-icon>
            </ion-col>
            <ion-col size="5">
                <ion-label>{{ 'DATE_FORMAT' | translate}}</ion-label>
            </ion-col>
            <ion-col size="5" class="end">
                <ion-select multiple="false" [(ngModel)]="selectedDateFormat" (ionChange)="changeDateFormat()"
                    cancelText="{{'GLOBAL_CANCEL' | translate}}" okText="{{'GLOBAL_OK' | translate}}"
                    [placeholder]="selectedDateFormatName">
                    <ion-select-option *ngFor="let format of formats" value="{{format.key}}">{{format.name }}
                    </ion-select-option>
                </ion-select>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>